import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirClinicalImpressions } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirClinicalImpressions.STARTED]: handleActionStart,
  [fetchFhirClinicalImpressions.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirClinicalImpressions.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.clinicalImpressions,
  [clearCurrentPatient]: () => initialState,
});
